import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "../assets/logo/logo.svg";

const productLinks = [
  ["Dashboards", "#dashboards", "Real-time operational visibility"],
  ["Automation", "#automation", "Turn routine work into workflows"],
  ["WhatsApp Automation", "#whatsapp", "Send updates without manual work"],
  ["Analytics & Reports", "#analytics", "Make decisions from your data"],
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
    setProductsOpen(false);
  }, [location.pathname]);

  const scrollTo = (id) => {
    setOpen(false);
    setProductsOpen(false);
    if (location.pathname !== "/") return;
    document.querySelector(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 border-b border-slate-200/80 bg-[#f7fbfd]/90 backdrop-blur-xl">
      <nav className="mx-auto flex h-[76px] max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8">
        <Link to="/" className="flex items-center" aria-label="Lightning Technologies home">
          <img src={Logo} alt="Lightning Technologies" className="h-11 w-auto sm:h-12" />
        </Link>

        <div className="hidden items-center gap-8 md:flex">
          <Link to="/" className="nav-link">Home</Link>

          <div className="relative">
            <button
              className="nav-link flex items-center gap-1"
              onClick={() => setProductsOpen((v) => !v)}
              aria-expanded={productsOpen}
            >
              Product <ChevronDown className={`h-4 w-4 transition-transform ${productsOpen ? "rotate-180" : ""}`} />
            </button>

            {productsOpen && (
              <div className="absolute left-1/2 top-full mt-4 w-[360px] -translate-x-1/2 rounded-2xl border border-slate-200 bg-white p-3 shadow-[0_22px_60px_rgba(0,52,72,0.16)]">
                <Link to="/#product" className="mb-2 block rounded-xl bg-[#eaf8fe] p-4" onClick={() => setProductsOpen(false)}>
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-[#003448]">MarketMind ERP</p>
                      <p className="mt-1 text-sm text-slate-600">Built for APMC and trading operations</p>
                    </div>
                    <ArrowUpRight className="h-5 w-5 text-[#00aef0]" />
                  </div>
                </Link>
                {productLinks.map(([title, id, desc]) => (
                  <button
                    key={id}
                    onClick={() => scrollTo(id)}
                    className="w-full rounded-xl p-3 text-left transition hover:bg-slate-50"
                  >
                    <p className="font-medium text-slate-900">{title}</p>
                    <p className="mt-0.5 text-xs text-slate-500">{desc}</p>
                  </button>
                ))}
              </div>
            )}
          </div>

          <Link to="/pricing" className="nav-link">Pricing</Link>
          <button onClick={() => scrollTo("#contact")} className="nav-link">Contact</button>
          <Link to="/pricing" className="btn-primary px-5 py-2.5">Book a Demo <ArrowUpRight className="h-4 w-4" /></Link>
        </div>

        <button className="rounded-xl p-2 text-[#003448] md:hidden" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
          {open ? <X /> : <Menu />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-slate-200 bg-white px-4 py-4 md:hidden">
          <div className="mx-auto flex max-w-7xl flex-col gap-1">
            <Link className="mobile-link" to="/">Home</Link>
            <Link className="mobile-link" to="/#product">Product</Link>
            <Link className="mobile-link" to="/#automation">Automation</Link>
            <Link className="mobile-link" to="/#whatsapp">WhatsApp Automation</Link>
            <Link className="mobile-link" to="/#analytics">Analytics</Link>
            <Link className="mobile-link" to="/pricing">Pricing</Link>
            <Link className="btn-primary mt-2 justify-center" to="/#contact">Book a Demo <ArrowUpRight className="h-4 w-4" /></Link>
          </div>
        </div>
      )}
    </header>
  );
}
